import React from 'react';
import DistributionForm from 'pages/admin/email/distribution/form/DistributionForm';

const DistributionCreate = () => {
    return <DistributionForm />;
};

export default DistributionCreate;
